import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/en")({
	headers: () => ({
		"Cache-Control":
			"public, max-age=0, s-maxage=3600, stale-while-revalidate=86400",
	}),
	head: () => ({
		meta: [
			{
				title: "Makedonijaturist AD",
			},
			{
				name: "description",
				content:
					"Makedonijaturist AD, corporate brand and hotel portfolio in Skopje. Local heart. Urban comfort.",
			},
			{
				property: "og:title",
				content: "Makedonijaturist AD",
			},
			{
				property: "og:description",
				content:
					"Makedonijaturist AD, corporate brand and hotel portfolio in Skopje. Local heart. Urban comfort.",
			},
			{
				property: "og:image",
				content: "https://makedonijaturist.com.mk/makedonijaturist.png",
			},
			{
				property: "og:type",
				content: "website",
			},
			{
				name: "twitter:card",
				content: "summary_large_image",
			},
			{
				name: "twitter:title",
				content: "Makedonijaturist AD",
			},
			{
				name: "twitter:description",
				content:
					"Makedonijaturist AD, corporate brand and hotel portfolio in Skopje. Local heart. Urban comfort.",
			},
			{
				name: "twitter:image",
				content: "https://makedonijaturist.com.mk/makedonijaturist.png",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://makedonijaturist.com.mk/en",
			},
		],
	}),
	component: () => <Outlet />,
});
